import React from "react";
import { connect, type ConnectedProps } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { BsCashStack } from "react-icons/bs";

import ActionCard from "components/ActionCard";
import { userIsPaychexRolloverOnly } from "store/selectors/user";
import { perksEnabled } from "utils/perksEnabled";
import { useAuth0 } from "utils/react-auth0-wrapper";
import type { RootState } from "types/state";

const mapStateToProps = (state: RootState) => ({
  isRolloverOnly: userIsPaychexRolloverOnly(state),
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const PerksEnrollmentCard = ({ isRolloverOnly }: PropsFromRedux) => {
  const { loginWithRedirect } = useAuth0();

  const enroll = () => {
    // Same mechanism PublicRoute uses: App's restore effect reads this on the
    // way back, since onRedirectCallback strips the query string.
    sessionStorage.setItem("auth0_postLoginRedirect", "/dashboard");
    void loginWithRedirect({
      authorizationParams: {
        connection: "Paychex",
        acr_values: "ira_deductions",
      },
      appState: { targetUrl: "/dashboard" },
    });
  };

  if (!perksEnabled() || !isRolloverOnly) {
    return null;
  }

  return (
    <Row>
      <Col md={6}>
        <ActionCard
          onClick={enroll}
          icon={<BsCashStack size={16} strokeWidth={0.5} color={"#1D99A9"} />}
          title={"Contribute to your IRA from every paycheck"}
          description={
            "Enroll in Paychex Perks to automatically set aside part of each paycheck for your retirement"
          }
          actionText={"Enroll in Paychex Perks"}
          color={"paychex"}
        />
      </Col>
    </Row>
  );
};

export default connector(PerksEnrollmentCard);
